import React, { Component } from 'react'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { Field, reduxForm, reset } from "redux-form"
import { Row, Col, Button, Table, Label, Modal, FormControl, OverlayTrigger, popover, overlay, FormGroup, ControlLabel, Panel } from 'react-bootstrap'
import { getOrderHistory, refreshOrderhistory, changeCardOmise } from '../actions'
import { changeOrderStatusToThaiLanguage, cuttingLongText, getMoneyFormat, getShortDateString, getTimeString } from '../utils'
import NavHeader from './navheader'
import Footer from './footer'
import SubMenu from './submenu'
import _ from 'lodash'
import ComponentCreditCardInput from './component_credit_card_input'

class OrderHistory extends Component {

    componentWillMount() {
        // window.Omise.setPublicKey('pkey_test_59lploy0m5cf9rpatre')
        if (localStorage.getItem('user') != null) {
            this.setState({ isLogin: true })
            this.props.getOrderHistory("", this.gettoken())
        } else {
            this.props.history.push('/login')
        }
        window.scrollTo(0, 0)
    }

    gettoken() {
        let user_info = JSON.parse(localStorage.getItem('user'))
        let user_address = user_info.address[Object.keys(user_info.address)[0]]
        let token = user_info.token
        return token
    }

    state = {
        user: JSON.parse(localStorage.getItem('user')),
        isLogin: false,
        showModal: false,
        name: '',
        input1: '',
        input2: '',
        input3: '',
        input4: '',
        input5: '',
        input6: '',
        input7: '',
        price: '',
        loadingModal: false,
        order_id: '',
        successful: ''
    }

    setParentState(key, value) {
        let newState = {}
        newState[key] = value
        this.setState({ ...newState })
    }

    onLogout() {
        localStorage.removeItem('user')
        this.props.history.push('/login')
    }

    openModal(price, order_id) {
        this.setState({ showModal: true, price: price, order_id: order_id })
    }

    closeModal() {
        this.setState({
            successful: true, price: '', order_id: '', loadingModal: false,
            name: '', input1: '', input2: '', input3: '',
            input4: '', input5: '', input6: '', input7: ''
        })
    }

    reverseObj(object) {
        var NewObj = {}, keysArr = Object.keys(object);
        for (var i = keysArr.length - 1; i >= 0; i--) {
            NewObj[keysArr[i]] = object[keysArr[i]];
        }
        return NewObj;
    }

    renderdata() {
        if (!this.props.orderhistory) {
            return (
                <div className="loader"></div>
            )
        }
        else if (this.props.orderhistory.success == false) {
            return (
                <div style={{ height: 200, textAlign: 'center' }}>
                    <br />
                    <span className="glyphicon glyphicon-remove" style={{ color: '#D50000', fontSize: 36 }}></span><h3>ไม่พบข้อมูลการสั่งซื้อของคุณ</h3>
                </div>
            )
        }
        else {
            let id = 0
            if (Object.keys(this.props.orderhistory).length = 0) {
                return (
                    <div className="loader"></div>
                )
            }
            else {
                let newObj = this.reverseObj(this.props.orderhistory)
                return _.map(newObj, row => {
                    return (
                        <Panel key={id++}>
                            <div>
                                <h5 className='pull-left' style={{ display: 'inline-block' }}>หมายเลขคำสั่งซื้อ {row.order_id}</h5>
                                {row.order_status == 'PaymentDenied' ?
                                    <button style={{ marginLeft: 10 }} className='btn btn-danger pull-right' onClick={() => { this.openModal(row.money_received, row.order_id) }}>เปลี่ยนข้อมูลบัตรเครดิตใหม่</button> : ''
                                }
                                <h5 className='pull-right hidden-xs' style={{ display: 'inline-block' }}>สถานะ : <strong>{changeOrderStatusToThaiLanguage(row.order_status)}</strong></h5>
                                <h5 className='hidden-sm hidden-md hidden-lg' style={{ display: 'inline-block' }}>สถานะ : <strong>{changeOrderStatusToThaiLanguage(row.order_status)}</strong></h5>
                                <div className='hidden-xs'><br /><br /></div>
                                <h5>วันที่: {getShortDateString(row.timestamp)} เวลา: {getTimeString(row.timestamp)} น.</h5>
                            </div>
                            <hr />
                            <div>
                                <h4 className='pull-left' style={{ display: 'inline-block', marginTop: 25 }}>จำนวนสินค้า {Object.keys(row.products).length} รายการ</h4>
                                <div className='pull-right' style={{ display: 'inline-block' }}><h4 style={{ display: 'inline-block' }}>ยอดคำสั่งซื้อ</h4><h3 style={{ display: 'inline-block' }}><strong>&nbsp;{getMoneyFormat((Math.round(row.money_received)).toFixed(2))} บาท</strong></h3></div>
                            </div>
                            <br /><br /><br />
                            <button className='pull-right btn btn-success' style={{ width: 170, height: 40, marginTop: 10 }} onClick={() => { this.onOpenOrderTab(row.url) }}>ดูรายละเอียด</button>
                        </Panel>
                    )
                })
            }
        }
    }

    onSubmitCreditCard() {
        let bool = true
        let values = {}
        this.state.name != '' ? values = { name: this.state.name } : bool = false
        for (let i = 1; i < 5; i++) {
            let state = 'input' + i
            this.state[state].length == 4 ? '' : bool = false
        }
        for (let i = 5; i < 7; i++) {
            let state = 'input' + i
            this.state[state].length == 2 ? '' : bool = false
        }
        this.state.input7.length == 3 ? '' : bool = false
        if (bool) {
            values['number'] = this.state.input1 + this.state.input2 + this.state.input3 + this.state.input4
            values['expiration_month'] = this.state.input5
            values['expiration_year'] = this.state.input6
            values['security_code'] = this.state.input7
            // console.log(values)
            this.omiseCreateToken(values)
            this.setState({ loadingModal: true })
            // this.setState({
            //     name: '', input1: '', input2: '', input3: '',
            //     input4: '', input5: '', input6: '', input7: ''
            // })
        } else {
            window.alert('กรุณากรอกข้อมูลให้ครบถ้วนถูกต้อง')
        }
    }

    changeCardOmise(credit_card_values) {
        this.props.changeCardOmise(credit_card_values, this.changeCardOmiseCallback.bind(this), this.changeCardOmiseCallbackErr.bind(this))
    }

    changeCardOmiseCallback() {
        this.props.getOrderHistory("", this.gettoken())
        this.closeModal()
    }

    changeCardOmiseCallbackErr(errormessage) {
        window.alert('ไม่สามารถชำระเงินผ่านบัตรเครดิตได้กรุณากรอกข้อมูลอีกครั้ง: ' + errormessage)
        this.setState({
            loadingModal: false, name: '', input1: '', input2: '', input3: '',
            input4: '', input5: '', input6: '', input7: ''
        })
        console.log('error: ' + errormessage)
    }

    omiseCreateToken(credit_card_values) {
        window.Omise.createToken('card', credit_card_values, (statusCode, response) => {
            if (statusCode === 200) {
                // Success: send back the TOKEN_ID to your server. The TOKEN_ID can be
                // found in `response.id`.
                // checkoutForm.omiseToken.value = response.id;
                // checkoutForm.submit();
                // console.log(response.id);
                // console.log('token', response.id)
                let values = { omiseToken: response.id, amount: (this.state.price * 100), orderId: this.state.order_id, phone_number: this.state.user.phone_number, email: this.state.user.email }
                // let values = { card: response.id, description: user_info.phone_number, email: user_info.email }
                // this.props.checkoutOmise(value_to_sent, this.checkoutOmiseCallback.bind(this), this.checkoutOmiseCallbackErr.bind(this))
                this.changeCardOmise(values)
            } else {
                // Error: display an error message. Note that `response.message` contains
                // a preformatted error message. Also note that `response.code` will be
                // "invalid_card" in case of validation error on the card.
                // console.log('resp', response)
                window.alert('ไม่สามารถชำระเงินผ่านบัตรเครดิตได้กรุณากรอกข้อมูลอีกครั้ง: ' + response.message)
                this.setState({
                    loadingModal: false, name: '', input1: '', input2: '', input3: '',
                    input4: '', input5: '', input6: '', input7: ''
                })
            }
        })
    }

    // checkoutOmiseCallback(credit_card_values) {
    //     this.omiseCreateCustomer(credit_card_values)
    // }

    // checkoutOmiseCallbackErr(errormessage) {
    //     window.alert('ไม่สามารถชำระเงินผ่านบัตรเครดิตได้กรุณากรอกข้อมูลบัตรใหม่อีกครั้ง ' + errormessage)
    //     console.log('error: ' + errormessage)
    //     this.setState({
    //         loadingModal: false, name: '', input1: '', input2: '', input3: '',
    //         input4: '', input5: '', input6: '', input7: ''
    //     })
    // }

    // omiseCreateCustomer(credit_card_values) {
    //     let user_info = JSON.parse(localStorage.getItem('user'))

    //     window.Omise.createToken('card', credit_card_values, (statusCode, response) => {
    //         if (statusCode === 200) {
    //             // Success: send back the TOKEN_ID to your server. The TOKEN_ID can be
    //             // found in `response.id`.
    //             // checkoutForm.omiseToken.value = response.id;
    //             // checkoutForm.submit();
    //             // console.log(response.id);
    //             let values = { card: response.id, description: user_info.phone_number, email: user_info.email }
    //             this.props.createCustomerOmise(values, this.omiseCreateCustomerCallback.bind(this), this.omiseCreateCustomerCallbackErr.bind(this))
    //         } else {
    //             // Error: display an error message. Note that `response.message` contains
    //             // a preformatted error message. Also note that `response.code` will be
    //             // "invalid_card" in case of validation error on the card.
    //             console.log('ไม่สามารถเพิ่มบัตรได้เนื่องจาก: ' + response.message)
    //         }
    //     })

    // }

    // omiseCreateCustomerCallback() {
    //     this.props.getOrderHistory("", this.gettoken())
    //     this.closeModal()
    // }

    // omiseCreateCustomerCallbackErr(message) {
    //     this.props.getOrderHistory("", this.gettoken())
    //     this.closeModal()
    //     console.log(message)
    // }

    onOpenOrderTab(url) {
        window.open('http://test-bof.songsod.com/order/' + url, '_blank')
    }

    ondeletevalue() {
        this.props.refreshOrderhistory()
        this.props.getOrderHistory("", this.gettoken())
        this.props.dispatch(reset('Searchform'));
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <label>{field.label}</label>
                <input placeholder={field.placeholder} className="form-control" type="text" {...field.input} />
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        );
    }

    onSubmit(values) {
        this.props.refreshOrderhistory()
        this.props.getOrderHistory(values, this.gettoken())
        this.props.dispatch(reset('Searchform'));
    }
    onChangeHandle(e) {
        this.props.refreshOrderhistory()
        this.props.getOrderHistory({ order_status: e.target.value }, this.gettoken())
    }

    render() {
        const { handleSubmit } = this.props;
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <div className="container">
                        <h2 style={{ marginLeft: 15, marginTop: 30 }}>ประวัติการสั่งซื้อ</h2>
                        {/* <div style={{ marginLeft: 15, marginRight: 15 }}>
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h3 className="panel-title">จัดเรียงตาม</h3>
                                </div>
                                <div className="panel-body">
                                    <form name="Searchform" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        <div className="col-xs-9 col-sm-10 col-md-10">
                                            <Field
                                                label='เลขที่คำสั่งซื้อ: '
                                                placeholder="เลขที่คำสั่งซื้อ"
                                                name="order_id"
                                                component={this.renderInputField}
                                            />
                                        </div>
                                        <div className="col-xs-3 col-sm-3 col-md-1">
                                            <Button className="btn btn-primary" style={{ marginTop: 25, color: 'white !important' }} type="submit">ค้นหา</Button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> */}
                        <div style={{ marginLeft: 15, marginRight: 15 }}>
                            <div className="panel panel-default">
                                <div className="panel-heading">
                                    <h3 className="panel-title">ออเดอร์ของคุณ</h3>
                                </div>
                                <div className="panel-body">
                                    {/* <div style={{ width: '50%', float: 'right' }}>
                                        <ControlLabel>ตัวกรองสถานะ: </ControlLabel>
                                        <Field
                                            label='สถานะ: '
                                            placeholder="status"
                                            name="order_status"
                                            component="select"
                                            className="form-control"
                                            onChange={(e) => { this.onChangeHandle(e) }}
                                        >
                                            <option value=""></option>
                                            <option value="Sent">จัดส่งแล้ว</option>
                                            <option value="Shopping">กำลังหยิบสินค้า</option>
                                            <option value="Pending">รอการชำระเงิน</option>
                                            <option value="Packaging">รอการจัดส่ง</option>
                                            <option value="CheckingPrice">กำลังเช็คราคา</option>
                                            <option value="Queuing">กำลังรอคิว</option>
                                            <option value="Reject">ยกเลิกการสั่งซื้อ</option>
                                            <option value="Checkorderrequest">รอการตรวจสอบข้อมูล</option>
                                            <option value="PaymentDenied">ปฏิเสธการตัดบัตรเครดิต</option>
                                            <option value="Reject">ลูกค้าปฏิเสธ</option>
                                        </Field>
                                    </div> */}
                                    <div>
                                        {(this.props.orderhistory_reload == 'loading' || this.props.orderhistory == 'loading'
                                            ? <div style={{ textAlign: 'center' }}><div className="loader"></div><div>กำลังโหลด</div></div>
                                            : this.renderdata()
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modal */}
                <Modal show={this.state.showModal} onHide={() => { this.setState({ successful: false, showModal: false }) }} >
                    <Modal.Header>
                        <Modal.Title>{this.state.successful ? <div><h4 style={{ textAlign: 'center' }}>ชำระเงินผ่านบัตรเครดิตเรียบร้อย ขอบคุณที่วางใจใช้บริการส่งสดค่ะ</h4></div>
                            : <div style={{ textAlign: 'center' }}>กรุณากรอกข้อมูลบัตรเครดิตใหม่ ยอดชำระ {this.state.price ? getMoneyFormat((this.state.price).toFixed(2)) : ''} บาท</div>
                        }</Modal.Title>
                        <Modal.Body>{this.state.successful ? '' :
                            <div className="panel panel-default" style={{ marginTop: 15 }}>
                                <div className="panel-body">
                                    <h3 className="panel-title" style={{ marginTop: 5, fontSize: 18 }}>ชำระผ่านบัตรเครดิต</h3>
                                    <img className="img-responsive pull-right" style={{ marginTop: -30, height: 40 }} src="../static/images/card_logo.png" />
                                    <br />
                                    <ComponentCreditCardInput
                                        setParentState={this.setParentState.bind(this)}
                                        input1={this.state.input1} input2={this.state.input2}
                                        input3={this.state.input3} input4={this.state.input4}
                                        input5={this.state.input5} input6={this.state.input6}
                                        input7={this.state.input7} name={this.state.name}
                                    />
                                </div>
                            </div>
                        }</Modal.Body>
                        <Modal.Footer>
                            {this.state.successful ? <button style={{ width: 170, height: 40 }} className='btn btn-success' onClick={() => { this.setState({ successful: false, showModal: false }) }}>ตกลง</button>
                                : this.state.loadingModal ? <div className='loader'></div> :
                                    <button style={{ width: 170, height: 40 }} className='btn btn-success' onClick={() => { this.onSubmitCreditCard() }}>ชำระเงิน</button>
                            }
                        </Modal.Footer>
                    </Modal.Header>
                </Modal>
                {/* Modal */}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        orderhistory: state.orderhistory_reducer,
        orderhistory_reload: state.loadingorderhistory_reducer
    };
}

export default reduxForm({
    form: "Searchform"
})(connect(mapStateToProps, { getOrderHistory, refreshOrderhistory, changeCardOmise })(OrderHistory));



// WEBPACK FOOTER //
// ./src/components/page_order_history.js